<template>
  <v-dialog v-model="dialog" max-width="420">
    <div>
      <div class="modal-header">
        <v-icon class="trash-icon" color="error">
          mdi-trash-can-outline
        </v-icon>
        <v-btn icon @click.native="$store.dispatch('messages/cancel')">
          <v-icon color="icon"> mdi-close </v-icon>
        </v-btn>
      </div>
      <div
        :class="{ 'mb-2': !message }"
        v-html="title"
        class="modal-headline"
      ></div>
      <v-card-text v-if="message" class="modal-subtext" v-html="message">
      </v-card-text>

      <div
        v-if="disclaimerText"
        class="va-disclaimer d-flex align-center"
        :class="`va-disclaimer--warning`"
      >
        <div class="va-disclaimer__icon d-flex align-center">
          <v-icon :size="25" color="warning">mdi-alert-circle</v-icon>
        </div>
        <div class="va-disclaimer__text d-flex flex-column">
          <!-- <span class="va-disclaimer__text-title"></span> -->
          <span
            class="va-disclaimer__text-content"
            v-html="disclaimerText"
          ></span>
        </div>
        <div class="va-disclaimer__action ml-auto d-flex align-center">
          <slot name="actions"></slot>
        </div>
      </div>

      <div class="modal-buttons">
        <v-btn
          color="body"
          outlined
          class="cancel-button"
          @click.native="$store.dispatch('messages/cancel')"
        >
          {{ cancel }}
        </v-btn>

        <v-btn
          class="confirm-button"
          color="error"
          @click.native="$store.dispatch('messages/agree')"
        >
          {{ confirm }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      title: null,
      message: null,
      disclaimerText: null,
      confirm: this.$t("va.confirm.yes"),
      cancel: this.$t("va.confirm.no"),
    };
  },
  watch: {
    "$store.state.messages.confirm"(newVal) {
      if (newVal) {
        // Used for generic resource deletion translation
        if (
          newVal.title.toLowerCase().includes("delete") &&
          this.$te("overrides.confirm.delete_resource_confirm") &&
          this.$te("overrides.confirm.delete_resource_cancel")
        ) {
          this.confirm = this.$t("overrides.confirm.delete_resource_confirm");
          this.cancel = this.$t("overrides.confirm.delete_resource_cancel");
        }
        this.dialog = true;
        this.title = newVal.title;
        this.message = newVal.message;
        this.disclaimerText = newVal.disclaimerText;
        return;
      }
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-header {
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
}
.trash-icon {
  display: flex;
  border-radius: 100% !important;
  width: 48px;
  height: 48px;
  &.theme--light {
    background: #ffecec;
    border: 5px solid #fafafa;
  }
  &.theme--dark {
    background: #3a3657;
    border: 5px solid #3e395d;
  }
}
.v-card__text {
  text-align: center;
  padding-bottom: 24px !important;
}
.modal-headline {
  font-size: 20px !important;
  text-align: left;
  font-weight: 500 !important;
  line-height: 32px !important;
  padding: 16px 24px 4px;
}

.modal-subtext {
  font-size: 14px;
  text-align: left;
  line-height: 24px !important;
  padding: 0 24px;
}

.modal-buttons {
  display: flex;
  padding: 0 24px;
  justify-content: space-between;
  button {
    width: calc(50% - 6px);
  }
}

.theme--light {
  .modal-subtext {
    color: #6c6c7d !important;
  }
}

.theme--dark {
  .modal-subtext {
    color: #afaac1 !important;
  }
}

.va-disclaimer {
  margin-bottom: 32px;
  margin-left: 24px;
  margin-right: 24px;
}
</style>
